/*
 * @Author: DouDou
 * @LastEditors: DouDou
 * @Date: 2020-09-28 16:03:35
 * @LastEditTime: 2020-10-09 15:40:21
 * @Description: File description
 */
import Vue from 'vue'
import Vuex from 'vuex'
import api from '../api/index'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: '',
    shareCountForGold: '--'
  },
  mutations: {
    setUserInfo (state, payload) {
      state.userInfo = payload
    },
    setShareCountForGold (state, payload) {
      state.shareCountForGold = payload
    }
  },
  actions: {
    async checkLogin ({ state, commit }) {
      if (state.userInfo) return Promise.resolve()
      const res = await api.checkLogin()
      if (res.stat === 1) {
        commit('setUserInfo', res.data)
        return Promise.resolve()
      }
      return Promise.reject(new Error('noLogin'))
    },
    changeShareCountForGold ({ commit }, payload) {
      commit('setShareCountForGold', payload)
    }
  },
  modules: {}
})
